import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    settings:{
      userId:null,
      sessionRunning:false,
      inventory:false,
      sessionId:null
    },

    swapOptions:[
      {value: "fruit", label: "Fruit"},
      {value: "vegetables", label:"Vegetables"},
      {value:"grain-not-whole", label:"Grains - Not Whole"},
      {value:"grain-whole", label:"Grains - Whole"},
      {value:"protein-plant", label:"Protein: Plant-Based"},
      {value:"protein-animal", label:"Protein: Animal"},
      {value:"combination-food-meal", label:"Combination Foods/Meals"},
      {value:"dairy-milk", label:"Dairy - Milk"},
      {value:"dairy-yogurt", label:"Dairy - Yogurt"},
      {value:"dairy-cheese", label:"Dairy - Cheese"},
      {value:"condiment", label:"Condiments"},
      {value:"beverage", label:"Beverages"},
      {value:"snack-dessert", label:"Snacks/Desserts"},
    ],

    swapRankings:[
      {value:"red", label:"Red"},
      {value:"green", label:"Green"},
      {value:"yellow", label:"Yellow"},
      {value:"unrankable-food", label:"Unrankable Food"},
      {value:"non-food", label:"Non-food"},
    ],

    cart:{
      items:[]
    }
  },
  mutations: {

  },
  actions: {

  }
})
